/**
 * @generated SignedSource<<f30c0f927b1d3ff15e268ba94dc8ab57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentDropdown_departments$data = ReadonlyArray<{
  readonly node: {
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly " $fragmentType": "DepartmentDropdown_departments";
}>;
export type DepartmentDropdown_departments$key = ReadonlyArray<{
  readonly " $data"?: DepartmentDropdown_departments$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentDropdown_departments">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DepartmentDropdown_departments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DepartmentType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DepartmentTypeEdge",
  "abstractKey": null
};

(node as any).hash = "7544d13ec178cb3f650ffe1bb2b14683";

export default node;
